<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" title="编辑" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="流水号">
					<el-input disabled v-model="form.orderNo"></el-input>
				</el-form-item>
<!-- 				<el-form-item label="供应商">
					<el-input disabled v-model="form.purchasesuppliername"></el-input>
				</el-form-item> -->
<!-- 				<el-form-item label="单据编码">
					<el-input v-model="form.serialNo" clearable></el-input>
				</el-form-item> -->
				<el-form-item label="万里牛">
					<el-input v-model="form.export_wln" clearable></el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				form: {
					orderNo: null,
					purchasesuppliername: null,
					//serialNo: null,
					export_wln: null,
				},
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.form.orderNo = this.row.orderNo
				this.form.purchasesuppliername = this.row.purchasesuppliername
				this.form.serialNo = this.row.serialNo
				this.form.export_wln = this.row.export_wln
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.form.orderNo = null
				this.form.purchasesuppliername = null
				this.form.serialNo = null
				this.form.export_wln = null
				this.$emit('hide')
			},
			show() {
				this.activeName = 'track'
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			submit() {
				//console.log(this.form)
				this.$api.reconciliation_bankflow.update(this.row.id, {
					original: this.row.original,
					serialNo: this.row.serialNo,
					detailid: this.row.detailid,
					relationorder: this.row.relationorder,
					export_wln: this.form.export_wln
				}).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.cancel()
				})

				//this.cancel()
			}
		},
		components: {

		}
	}
</script>